module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [(_vm.administrador === true) ? _c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Nova Mensagem'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-container', [_c('v-dialog', {
    attrs: {
      "width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-2",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n                    Confirma a mensagem inicial?\n                  ")]), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.novaMensagem
    }
  }, [_vm._v("Sim")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Título",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.mensagem.titulo),
      callback: function($$v) {
        _vm.$set(_vm.mensagem, "titulo", $$v)
      },
      expression: "mensagem.titulo"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('c-textarea', {
    attrs: {
      "label": "Texto",
      "rules": _vm.regrasBasicas,
      "rows": 3,
      "auto-grow": true,
      "multi-line": "",
      "counter": "2000"
    },
    model: {
      value: (_vm.mensagem.texto),
      callback: function($$v) {
        _vm.$set(_vm.mensagem, "texto", $$v)
      },
      expression: "mensagem.texto"
    }
  })], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mt-3"
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.cancelar
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("Salvar")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fdde17b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/nova-mensagem.vue
// module id = 721
// module chunks = 0